export default "__VITE_ASSET__DjeqHan4__"